



import {
    getClokInReport,
    getCoinManagement,
    getMeterReport,
    getPosReport,
    getPosSummaryReport,
    getPosStatusLookup,
    getPosDetailJobStatus,
    getDashboardVendingReport,
    getGasReport,
    getMachineHistoryReport,
    getOtteriReport,
    getOtherReport,
    getOtherReportName,
    getInternalReport,
    getClokInExport,
    getIroingServiceReport,
    getSSRSSubscriptionReport,
    getPosSummaryReportDelivery,
    getWdfServiceTypeLov
} from '../utils/api-action';



const clockinReport = async (param) => {
    var result = await getClokInReport(param)
    return result;

}

const getClockinExport = async (param) => {
    var result = await getClokInExport(param)
    return result;

}


const coinManagement = async (param) => {
    var result = await getCoinManagement(param)
    return result;

}

const meterReport = async (param) => {
    var result = await getMeterReport(param)
    return result;

}
const posReport = async (param) => {
    var result = await getPosReport(param)
    return result;

}

const posSummaryReport = async (param) => {
    var result = await getPosSummaryReport(param)
    return result;

}

const posStatusLookup = async () => {
    var result = await getPosStatusLookup()
    return result;

}

const PosSummaryReportDelivery = async (param) => {
    var result = await getPosSummaryReportDelivery(param)
    return result;

}

const posDetailJobStatus = async (param) => {
    var result = await getPosDetailJobStatus(param)
    return result;

}

const dashboardVendingReport = async (param) => {
    var result = await getDashboardVendingReport(param)
    return result;

}

const gasReport = async (param) => {
    var result = await getGasReport(param)
    return result;

}

const machineHistoryReport = async (param) => {
    var result = await getMachineHistoryReport(param)
    return result;
}

const otteriReport = async (param) => {
    var result = await getOtteriReport(param)
    return result;
}

const otherReportName = async () => {
    var result = await getOtherReportName()
    return result;
}

const otherReport = async (param) => {
    var result = await getOtherReport(param)
    return result;
}

const internalReport = async (param) => {
    var result = await getInternalReport(param)
    return result;
}

const ironingServiceReport = async (param) => {
    var result = await getIroingServiceReport(param)
    return result;
}


const ssrsSubscriptionReport = async (param) => {
    var result = await getSSRSSubscriptionReport(param)
    return result;
}
export {
    clockinReport
    , coinManagement
    , meterReport
    , posReport
    , posSummaryReport
    , posStatusLookup
    , posDetailJobStatus
    , dashboardVendingReport
    , gasReport
    , machineHistoryReport
    , otteriReport
    , otherReportName
    , otherReport
    , internalReport
    , getClockinExport
    , ironingServiceReport
    , ssrsSubscriptionReport
    , PosSummaryReportDelivery
    , getWdfServiceTypeLov

};